import Typography from "@mui/material/Typography";

import { formatGuestBreakdown, totalGuestsFromForm } from "@/utils/partySize";

interface Props {
    adults: number;
    kids: number;
    highchairs: number;
}

// Adults, kids and highchairs are separate numbers, so the guest sees the sum spelled out.
export const GuestTotalLine = ({ adults, kids, highchairs }: Props) => {
    const total = totalGuestsFromForm({ adults, kids, highchairs });
    const breakdown = formatGuestBreakdown({
        countAdults: adults,
        countKids: kids,
        countHighchairs: highchairs,
    });
    return (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Total: <strong>{total === 1 ? "1 guest" : `${total} guests`}</strong> ({breakdown})
        </Typography>
    );
};
